import { mCalendarClsPrefix } from '../../constants/index.m';
import Loadable from '../../react-loadable';
import { MCalendarType } from './types';

const MCalendar = Loadable({
  name: 'MCalendar',
  loader: () => import(
    /* webpackChunkName: "ui_m_commont_other" */
    './Calendar.m')
}) as MCalendarType;

MCalendar.defaultProps = {
  prefixCls: mCalendarClsPrefix
};

export type { MCalendarProps } from './types';

export default MCalendar;
